import mod from "-!./EcOrdersList.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./EcOrdersList.js?vue&type=script&lang=js&external"